import { importDynamicData } from '../importDynamicData';

export enum ThankYouPageVariant {
  DEFAULT = 'DEFAULT',
  AUCTION_CONSULTANCY = 'AUCTION_CONSULTANCY',
  BUYER_CONSULTANCY = 'BUYER_CONSULTANCY',
  JOB_APPLICATION = 'JOB_APPLICATION',
}

export async function getThankYouData(variant?: ThankYouPageVariant): Promise<any> {
  return variant
    ? importDynamicData(`thank-you/${variant.toLowerCase().replace(/_/g, '-')}.yml`)
      .catch((_) => ({}))
    : Promise.resolve({});
}
